import { HeaderBackButton, HeaderBackButtonProps } from '@react-navigation/elements'
import React from 'react'

import { useConfig } from '../../context/config'
import { redirect } from '../../util/navigation'
import { ArrowLeft } from '../images/Common/ArrowLeft'

export const SignInHeaderLeft: React.FC<HeaderBackButtonProps> = props => {
  const { config } = useConfig()

  return (
    // override the back button to have a persistent button
    // that goes to the marketingHomepageURL if there isn't back behaviour
    <HeaderBackButton
      disabled={props.disabled}
      backImage={ArrowLeft}
      {...props}
      onPress={!props.canGoBack ? () => redirect(config.marketingHomepageURL) : props.onPress}
    />
  )
}

export default SignInHeaderLeft
